import { useCallback, useState } from 'react';

const STORAGE_KEY = 'sidebar-collapsed';

/**
 * Collapsed/expanded state for the internal app sidebar, persisted to
 * localStorage so the practitioner's choice survives reloads.
 */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => {
    // localStorage access can throw (Safari private mode, storage-denied
    // iframes) — degrade to the default expanded state instead of
    // breaking the layout mount.
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });
  const toggle = useCallback(() => {
    setCollapsed((current) => {
      const next = !current;
      try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch {
        // State still toggles in-memory when persistence is unavailable.
      }
      return next;
    });
  }, []);
  return [collapsed, toggle] as const;
}
